/**
 * Merges current and comparison period items into a unified list.
 * Ensures accounts that exist only in the comparison period are included
 * with zero current-period amounts, so the rendered line items always
 * sum to the displayed totals.
 */
export function mergeComparisonItems(currentItems, comparisonItems) {
  const current = Array.isArray(currentItems) ? currentItems : [];
  const comparison = Array.isArray(comparisonItems) ? comparisonItems : [];

  if (comparison.length === 0) return current;

  const merged = [...current];

  comparison.forEach((compItem) => {
    const existsInCurrent = current.some(
      (c) =>
        (c.code && compItem.code && c.code === compItem.code) ||
        (c.name && compItem.name && c.name === compItem.name)
    );
    if (!existsInCurrent) {
      merged.push({
        ...compItem,
        balance: 0,
        amount: 0,
        _isComparisonOnly: true,
      });
    }
  });

  return merged;
}
